import React from "react";
import { Assignment as AssignmentIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { User, AssignmentSubmission } from "../../types";

export interface Props {
  user: User;
  assignmentSubmissions: AssignmentSubmission[];
  submissionAuthors: User[];
}

export const AssignmentSubmissionButton = ({
  assignmentSubmissions,
  submissionAuthors,
  user,
}: Props) => {
  function getAssignmentSubmission(user: User) {
    return assignmentSubmissions.find(
      (submission) => user.id === submission.authorId,
    );
  }

  return (
    <Tooltip title="Assignment Submission">
      <IconButton
        edge="end"
        aria-label="assignment submission link"
        href={getAssignmentSubmission(user)?.tokenizedLink || ""}
        disabled={!submissionAuthors.includes(user)}
      >
        <AssignmentIcon />
      </IconButton>
    </Tooltip>
  );
};
